import React from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import { useTranslation } from "react-i18next";
import SuccessIcon from "../../../../../../../../assets/images/success-icon-component.svg";
import Colors from "../../../../../constants/colors";
import { ComponentStyles } from "../../../../../constants/componentStyles";

type Props = {};

export default function MapiFraudPreventionStep(_: Props) {
  const { t } = useTranslation();

  return (
    <ScrollView
      testID="mapi-step-fraudPrevention"
      style={styles.container}
      contentContainerStyle={styles.content}
      showsVerticalScrollIndicator={false}
    >
      <View style={styles.iconCircle}>
        <SuccessIcon width={64} height={64} />
        <Text style={styles.title}>Fraud prevention</Text>
      </View>

      <Text style={styles.subtitle}>
        Fraud warning about your money transfer
      </Text>

      <Text style={styles.paragraph}>
        Keep your money safe. If any of the below apply,{" "}
        DO NOT SEND the money transfer. It's a scam and someone is trying to
        steal your money. If you send money, it can be paid out quickly, and you
        may not be able to get a refund.
      </Text>

      <View style={styles.list}>
        <Text style={styles.paragraph}>
          1. To donate to a charity or to pay an internet merchant during a
          crisis
        </Text>
        <Text style={styles.paragraph}>
          2. To receive money (e.g., lottery winnings, prizes or job offers)
        </Text>
        <Text style={styles.paragraph}>3. To pay the IRS or police</Text>
        <Text style={styles.listItem}>
          4. To buy a car, paragraph or other high-value item, or for "escrow"
          for housing
        </Text>
      </View>

      <Text style={styles.paragraph}>
        If you feel like you are a victim of fraud please call 1-800-926-9400
        for assistance or visit www.moneygram.com and file a complaint.
      </Text>

      <Text style={[styles.paragraph, { fontWeight: "500" }]}>
        Are you sending money for something a telemarketer sold you?
      </Text>

      <Text style={styles.paragraph}>
        Sellers and telemarketers can't take money transfer payments from people
        in the US for something they're selling.
      </Text>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  content: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 40,
  },
  iconCircle: {
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: "500",
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 32,
    paddingTop: 24,
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: 14,
    fontWeight: "500",
    color: Colors.subTitleColor,
    lineHeight: 22,
    marginBottom: 24,
  },
  paragraph: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: 14,
    fontWeight: "400",
    color: Colors.subTitleColor,
    lineHeight: 22,
    marginBottom: 16,
  },
  list: { marginBottom: 16 },
  listItem: {
    fontSize: 14,
    color: "#444",
    marginBottom: 8,
    lineHeight: 20,
  },
});
